import { Corpus } from "@pienso/ingest-types/corpus.interface";
import { Type } from "@angular/core";

export class ToolbarItem {
  public corpus: Corpus | undefined;
  constructor(public component: Type<any>) {}
}
